import { assetUrl } from '@/lib/assetUrl'

type Props = { size?: 'sm' | 'md' | 'lg'; forceWhite?: boolean; className?: string }

const heights: Record<string, string> = { sm: 'h-8', md: 'h-10', lg: 'h-16' }

export default function TrendLogo({ size = 'sm', forceWhite = false, className = '' }: Props) {
  const src = assetUrl(forceWhite ? 'brand/trend-logo-white.svg' : 'brand/trend-logo-dark.svg')
  // SVG logo — next/image adds overhead with no win here. src is routed
  // through assetUrl() so a CDN swap is one env var away (Phase 2.5b).
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt="Trend"
      width={515}
      height={199}
      className={`${heights[size]} w-auto ${className}`}
    />
  )
}
